import React, { Component } from 'react'

class Screen2 extends Component {

  render() {

    const { entry, goNext, addEntry, language, t } = this.props
    const forms = [t(language, 'incident'), t(language, 'socialMedia'), t(language, 'media'), t(language, 'publicArea'), t(language, 'publicGathering')]

    return (
      <main>
        <h3>{t(language, 'reportType')}</h3>
        {forms.map(form =>
          <button className="black square text-hover text-hover-fill-opening-horizontal" disabled={entry.form === form} onClick={() => {goNext(); addEntry('form', form)}}>{form}</button>
        )}
      </main>
    );
  }
}

export default Screen2;
